/**
 * Configurazione SEO centralizzata per tutte le pagine
 * Questo file viene usato sia dal componente SEO che dallo script di build
 */

export const SITE_CONFIG = {
  siteUrl: 'https://99castelli.it',
  siteName: 'ASD 99 Castelli',
  defaultTitle: 'ASD 99 Castelli - Riscopriamo i Castelli di L\'Aquila',
  defaultDescription: 'Associazione Sportiva Dilettantistica dedicata alla riscoperta dei 99 castelli che fondarono L\'Aquila. Escursioni a piedi e in bicicletta nel territorio aquilano.',
  defaultImage: '/images/og-default.jpg',
  locale: 'it_IT',
  twitterHandle: '@99castelli',
  facebookAppId: '',
};

export interface PageSEO {
  path: string;
  title: string;
  description: string;
  keywords: string[];
  image?: string;
  type?: 'website' | 'article';
  noindex?: boolean;
}

export const PAGE_SEO: PageSEO[] = [
  {
    path: '/',
    title: 'ASD 99 Castelli - Riscopriamo i Castelli di L\'Aquila',
    description: 'Associazione Sportiva Dilettantistica dedicata alla riscoperta dei 99 castelli che fondarono L\'Aquila nel 1254. Escursioni a piedi e in bicicletta, eventi culturali e valorizzazione del patrimonio storico abruzzese.',
    keywords: ['99 castelli', 'L\'Aquila', 'escursioni', 'bicicletta', 'trekking', 'Abruzzo', 'castelli medievali', 'storia aquilana'],
    image: '/images/og-home.jpg',
    type: 'website',
  },
  {
    path: '/associazione',
    title: 'Chi Siamo - ASD 99 Castelli | La Nostra Storia e Missione',
    description: 'Scopri la storia dell\'ASD 99 Castelli, fondata da Alessandro Serreli. Un\'associazione nata dalla passione per la storia del territorio aquilano e la riscoperta dei castelli medievali.',
    keywords: ['associazione 99 castelli', 'Alessandro Serreli', 'storia L\'Aquila', 'guida cicloturistica', 'CSI L\'Aquila'],
    image: '/images/og-associazione.jpg',
    type: 'website',
  },
  {
    path: '/tesseramento',
    title: 'Tesseramento 2026 - Diventa Socio ASD 99 Castelli',
    description: 'Iscriviti all\'ASD 99 Castelli per il 2026. Quote da €20 per adulti, €15 per minori. Assicurazione infortuni inclusa, partecipazione a tutte le attività e sconti esclusivi.',
    keywords: ['tesseramento 99 castelli', 'iscrizione ASD', 'socio 99 castelli', 'quote associative', 'CSI tesseramento'],
    image: '/images/og-tesseramento.jpg',
    type: 'website',
  },
  {
    path: '/attivita',
    title: 'Attività ed Eventi - Escursioni e Pedalate | ASD 99 Castelli',
    description: 'Calendario completo delle attività dell\'ASD 99 Castelli: escursioni a piedi, pedalate in bicicletta, visite guidate ai castelli del territorio aquilano. Scopri i prossimi eventi!',
    keywords: ['eventi 99 castelli', 'escursioni L\'Aquila', 'pedalate Abruzzo', 'trekking castelli', 'calendario attività'],
    image: '/images/og-attivita.jpg',
    type: 'website',
  },
  {
    path: '/castelli',
    title: 'I 99 Castelli di L\'Aquila - Mappa Interattiva e Storia',
    description: 'Esplora la mappa interattiva dei 99 castelli che nel 1254 fondarono la città di L\'Aquila. Storia, posizione e informazioni su torri, rocche e strutture difensive medievali.',
    keywords: ['99 castelli L\'Aquila', 'mappa castelli', 'castelli medievali Abruzzo', 'Rocca Calascio', 'torri aquilane', 'storia 1254'],
    image: '/images/og-castelli.jpg',
    type: 'website',
  },
  {
    path: '/laquila-cecilia',
    title: 'L\'Aquila Cecilia - Libro per Bambini sulla Storia di L\'Aquila',
    description: 'Scarica gratis "L\'Aquila Cecilia", il libro illustrato per bambini dai 4 ai 10 anni che racconta la storia di L\'Aquila attraverso gli occhi di una piccola aquila del Gran Sasso.',
    keywords: ['L\'Aquila Cecilia', 'libro bambini L\'Aquila', 'Alessandro Serreli', 'storia L\'Aquila bambini', 'ebook gratuito'],
    image: '/images/og-laquila-cecilia.jpg',
    type: 'article',
  },
  {
    path: '/documenti',
    title: 'Documenti e Moduli - ASD 99 Castelli',
    description: 'Scarica i moduli e documenti ufficiali dell\'ASD 99 Castelli: domanda di ammissione, liberatoria minori, autorizzazione immagini e informativa privacy.',
    keywords: ['documenti 99 castelli', 'moduli iscrizione', 'liberatoria ASD', 'modulo tesseramento'],
    image: '/images/og-documenti.jpg',
    type: 'website',
  },
  {
    path: '/trasparenza',
    title: 'Trasparenza - Statuto e Documenti Ufficiali | ASD 99 Castelli',
    description: 'Area trasparenza dell\'ASD 99 Castelli: statuto associativo, condizioni di partecipazione alle attività e informativa sulla privacy. Codice Fiscale 93083030662.',
    keywords: ['statuto 99 castelli', 'trasparenza ASD', 'documenti ufficiali', 'codice fiscale'],
    image: '/images/og-trasparenza.jpg',
    type: 'website',
  },
  {
    path: '/attestati',
    title: 'Attestati e Certificazioni - ASD 99 Castelli',
    description: 'Attestati, certificazioni e riconoscimenti ottenuti dall\'ASD 99 Castelli. Affiliazione CSI e qualifiche delle guide cicloturistiche.',
    keywords: ['attestati 99 castelli', 'certificazioni CSI', 'guida cicloturistica certificata'],
    image: '/images/og-attestati.jpg',
    type: 'website',
  },
  {
    path: '/amici',
    title: 'Partner e Collaborazioni - Amici di ASD 99 Castelli',
    description: 'I partner e le associazioni che collaborano con ASD 99 Castelli per la valorizzazione del territorio aquilano e l\'organizzazione di eventi culturali e sportivi.',
    keywords: ['partner 99 castelli', 'collaborazioni', 'associazioni L\'Aquila', 'enti locali'],
    image: '/images/og-amici.jpg',
    type: 'website',
  },
  {
    path: '/privacy',
    title: 'Privacy Policy - Informativa sulla Privacy | ASD 99 Castelli',
    description: 'Informativa sulla privacy dell\'ASD 99 Castelli ai sensi del GDPR. Come trattiamo i tuoi dati personali, finalità del trattamento e diritti degli interessati.',
    keywords: ['privacy policy', 'GDPR', 'protezione dati', 'informativa privacy'],
    noindex: true,
    type: 'website',
  },
  {
    path: '/termini',
    title: 'Termini di Servizio - Condizioni d\'Uso | ASD 99 Castelli',
    description: 'Termini e condizioni d\'uso del sito web dell\'ASD 99 Castelli. Regole per l\'utilizzo dei servizi e responsabilità degli utenti.',
    keywords: ['termini servizio', 'condizioni uso', 'regolamento sito'],
    noindex: true,
    type: 'website',
  },
];

// Helper per normalizzare il path (rimuove trailing slash)
export function normalizePath(path: string): string {
  if (path === '/') return path;
  return path.endsWith('/') ? path.slice(0, -1) : path;
}

// Helper per ottenere i dati SEO di una pagina
export function getPageSEO(path: string): PageSEO | undefined {
  const normalizedPath = normalizePath(path);
  return PAGE_SEO.find(page => page.path === normalizedPath);
}

// Helper per generare URL completo (con trailing slash per tutte le pagine eccetto root)
export function getFullUrl(path: string): string {
  const normalizedPath = normalizePath(path);
  // Cloudflare Pages aggiunge sempre trailing slash, quindi lo includiamo per coerenza
  if (normalizedPath === '/') {
    return `${SITE_CONFIG.siteUrl}/`;
  }
  return `${SITE_CONFIG.siteUrl}${normalizedPath}/`;
}

// Helper per generare URL immagine completo
export function getImageUrl(image?: string): string {
  const img = image || SITE_CONFIG.defaultImage;
  if (img.startsWith('http')) return img;
  return `${SITE_CONFIG.siteUrl}${img}`;
}
